//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { repeatCheckMemberApi } from '@/api/config';
import { contractList } from '@/api/enterprise';
export default {
  name: 'CrmebOaEntNotJoin',
  data: function data() {
    return {
      drawer: false,
      tableData: [],
      ids: []
    };
  },
  methods: {
    openBox: function openBox(data) {
      console.log(data, 'shuj ');
      // 获取部门人员禁用名单

      // repeatCheckMemberApi(data).then((res) => {
      //   this.drawer = true
      //   this.tableData = res.data
      // })
      this.drawer = true;
      this.tableData = data;
    },
    submitForm: function submitForm() {
      this.$emit('otherFiltersFn', this.ids);
      this.handleClose();
    },
    handleClose: function handleClose() {
      this.drawer = false;
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this = this;
      this.ids = [];
      if (e.length !== 0) {
        e.map(function (item) {
          _this.ids.push(item.id);
        });
      }
    }
  }
};